import { ModuleContainer } from './style';
import { Header, Footer } from 'components';
import ModulesContent from './components/ModulesContent';
import Welcome from 'components/Welcome';

const Modules = () => {
  return (
    <ModuleContainer>
      <Header reduceHeader={false} />
      <Welcome />
      <ModulesContent />
      <Footer
        backgroundColor={'var(--color-secondary-background-color)'}
        hasLogo
      />
    </ModuleContainer>
  );
};

export default Modules;
